import { createContext } from 'react';
import { WalletContextType } from '../types';

// 创建一个空的 Context，初始值设为 null
export const WalletContext = createContext<WalletContextType | null>(null);
